import React from 'react'
import SettingsMetaData from '../../../../../Components/Hooks/useSettingsMetaData';

const CustomerType = () => {
    return (
        <SettingsMetaData propertyName={"customerType_Customer"} viewPropertyName={"Customer Type"} />
      );
}

export default CustomerType